import { CoverBackground } from 'components/CoverBackground'
import { ComponentType } from 'react'
import { FaWhatsapp } from 'react-icons/fa'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;

  ${up('sm')} {
    display: block;
  }
`

const Photo = styled(CoverBackground)`
  width: 100px;
  background: #f7f8f9;
  border-radius: 3px 0 0 3px;

  ${up('sm')} {
    height: 0px;
    padding-bottom: 120%;
    width: auto;
    border-radius: 5px 5px 0 0;
  }
`

const Body = styled.div`
  padding: 10px 16px;
  flex: 1 1 auto;

  ${up('sm')} {
    padding: 12px 13px;
  }
`

const Name = styled.h6`
  margin-bottom: 5px;
  font-size: 15px;
  font-weight: bold;
  line-height: 18px;

  ${up('sm')} {
    font-size: 16px;
    line-height: 19px;
  }
`

const Contact = styled.div`
  display: flex;
  margin-bottom: 12px;
  align-items: center;
  justify-content: space-between;
`

const Phone = styled.a`
  color: #505862;
`

const Email = styled.a`
  font-size: 14px;
  line-height: 1;

  ${up('sm')} {
    font-size: 16px;
  }
`

export const AgentCard: ComponentType<{ agent: any }> = ({ agent }) => {
  const [emailName, emailAt] = agent.email.split('@')

  return (
    <Wrapper>
      <Photo url={agent.avatar.thumbnailUrl} />
      <Body>
        <Name>
          {agent.firstName} {agent.lastName}
        </Name>
        <Contact>
          <Phone href={`tel:${agent.phone1}`}>{agent.phone1}</Phone>
          {agent.whatsapp && <a href={`https://wa.me/521${agent.whatsapp}`} title="Contactar por WhatsApp" target="_blank">
            <FaWhatsapp size={18} color="#0fb04b" />
          </a>}
        </Contact>
        <Email href={`mailto:${agent.email}`}>
          {emailName} <br /> @{emailAt}
        </Email>
      </Body>
    </Wrapper>
  )
}
